const config = [],defaultPath='/user';
module.exports =  {config,defaultPath};

// this.key_name = this.$route.query.key_name;
// this.isSystem = Boolean(this.$route.query.isSystem);
// this.relation_id = parseInt(this.$route.query.relation_id) || 0;
config.push({ path: '/login',component: () => import( '../modules/Login.vue') });
config.push({ path: '/user',component: () => import( '../User.vue') });

config.push({ path: '/user/user/list',parent:'/user'
    ,component: () => import( '../modules/UserList.vue') });

config.push({ path: '/user/user/report',parent:'/user'
    ,component: () => import( '../modules/ReportList.vue') });

config.push({ path: '/user/partner/list',parent:'/user'
    ,component: () => import( '../modules/PartnerList.vue') });

config.push({ path: '/user/explain/custom/list',parent:'/user'
    ,component: () => import( '../modules/CustomExplainList.vue') });

config.push({ path: '/user/pk/sh/list',parent:'/user'
    ,component: () => import( '../modules/PkShList.vue') });

config.push({ path: '/user/pk/sh/log/list',parent:'/user'
    ,component: () => import( '../modules/PkShLogList.vue') });

config.push({ path: '/user/pk/active/log/feedback/list',parent:'/user'
    ,component: () => import( '../modules/PkActiveLogFeedbackList.vue') });

config.push({ path: '/user/pk/degree/config/list',parent:'/user'
    ,component: () => import( '../modules/PkDegreeConfig.vue') });

config.push({ path: '/user/pk/list',parent:'/user'
    ,component: () => import( '../modules/PkList.vue') });

config.push({ path: '/user/pvp/list',parent:'/user'
    ,component: () => import( '../modules/PvpList.vue') });

config.push({ path: '/independent/ltd/list'
    ,component: () => import( '../modules/SingleLtdList.vue') });
config.push({ path: '/user/ltd/list',parent:'/user'
    ,component: () => import( '../modules/LtdList.vue') });

config.push({ path: '/user/pk/finale/explain',parent:'/user'
    ,component: () => import( '../modules/FinalExplainForPk.vue') });

config.push({ path: '/user/pk/classics/situation',parent:'/user'
    ,component: () => import( '../modules/PkClassicsSituation.vue') });

config.push({ path: '/chart/pk/active/log'
    ,component: () => import( '../modules/PkActiveLogChart.vue') });

config.push({ path: '/user/pk/evalution/speechcraft/edit',parent:'/user'
    ,component: () => import( '../modules/PkEvalutionSpeechcraftEdit.vue') });

config.push({ path: '/user/task/conf/list',parent:'/user'
    ,component: () => import( '../modules/TaskConfList.vue') });

config.push({ path: '/user/llm/support/list',parent:''
    ,component: () => import( '../modules/LlmSupportList.vue') });

config.push({ path: '/user/task/user/list',parent:'/user'
    ,component: () => import( '../modules/TaskUserList.vue') });

config.push({ path: '/user/room/list',parent:'/user'
    ,component: () => import( '../modules/RoomList.vue') });

config.push({ path: '/user/pk/package/list',parent:'/user'
    ,component: () => import( '../modules/PkgList.vue') });

config.push({ path: '/user/pk/package/attach/list',parent:'/user'
    ,component: () => import( '../modules/PkgAttachList.vue') });

config.push({ path: '/user/partner/tools1',parent:'/user'
    ,component: () => import( '../modules/PracticeTools1.vue') });

config.push({ path: '/user/pvp/activity/list',parent:'/user'
    ,component: () => import( '../modules/PvpActivityList.vue') });

config.push({ path: '/user/pvp/evaluate/list',parent:'/user'
    ,component: () => import( '../modules/PvpEvaluateList.vue') });

config.push({ path: '/user/pk/activity/list',parent:'/user'
    ,component: () => import( '../modules/PkInviteList.vue') });







    
// config.push( {path:'/user/extended/info/:key_name/:relation_id/:isSystem',parent:'/user',
//     component: () => import( '../modules/ExtendedInfo.vue') });

// config.push({ path: '/user/upload',parent:'/user',
//     component: () => import( '../modules/Upload.vue') });

// config.push({ path: '/user/category/edit',parent:'/user'
//     ,component: () => import( '../modules/EditCategory.vue')});

// config.push({ path: '/user/article/list',parent:'/user'
//     ,component: () => import( '../modules/ArticleList.vue')});
// config.push({ path: '/user/article/list/info',parent:'/user'
//     ,component: () => import( '../modules/ArticleInfo.vue')});

// config.push({ path: '/vote/list',parent:'/user'
//     ,component: () => import( '../modules/VoteList.vue')});
// config.push({ path: '/template/list/:id',parent:'/user'
//     ,component: () => import( '../modules/TemplateList.vue')});
// config.push({ path: '/vote/player/list/:id',parent:'/user'
//     ,component: () => import( '../modules/VotePlayerList.vue')});

// config.push({ path: '/black/list',parent:'/user'
//     ,component: () => import( '../modules/BlackIpList.vue')});
// config.push({ path: '/comment/list/:id',parent:'/user'
//     ,component: () => import( '../modules/CommentList.vue')});
// config.push({ path: '/work/order/list',parent:'/user'
//     ,component: () => import( '../modules/WorkOrderList.vue')});
// config.push({ path: '/customer/service/list',parent:'/user'
//     ,component: () => import( '../modules/CustomerServiceList.vue')});


// config.push({ path: '/user/system/logs',parent:'/user'
//     ,component: () => import( '../modules/SystemLog.vue') });
// config.push({ path: '/user/system/server',parent:'/user'
//     ,component: () => import( '../modules/StatisticsServer.vue') });
// config.push({ path: '/user/system/user',parent:'/user'
//     ,component: () => import( '../modules/StatisticsUser.vue') });



